module.exports = __webpack_public_path__ + "static/media/sleigh.65f3fa16.svg";